export default "__VITE_ASSET__BOnphrOW__"